export const shoppingTipsArticleId = 22;
